export const messages = {
  en: {
    orderWriteOffConfirm: {
      writeOff: 'Write Off',
      queryCondition: 'Query Condition',
      inputUserName: 'Please input user name',
      inputWriteOffNum: 'Please input write off number',
      query: 'Query',
      orderNum: 'Order Number',
      productName: 'Product Name',
      quantity: 'Quantity',
      productStatus: 'Product Status',
      userName: 'User Name',
      paymentAmount: 'Payment Amount',
      writeOffNum: 'Write Off Number',
      phoneLastFour: 'Last 4 Phone Digits',
      writeOffStatus: 'Write Off Status',
      writeOffTime: 'Write Off Time',
      remark: 'Remark',
      operation: 'Operation',
      orderDetail: 'Order Detail'
    }
  },
  zh: {
    orderWriteOffConfirm: {
      writeOff: '核销',
      queryCondition: '查询条件',
      inputUserName: '请输入用户名称',
      inputWriteOffNum: '请输入核销单号',
      query: '查询',
      orderNum: '订单编号',
      productName: '商品名称',
      quantity: '数量',
      productStatus: '商品状态',
      userName: '用户名称',
      paymentAmount: '支付金额',
      writeOffNum: '核销单号',
      phoneLastFour: '手机后四位',
      writeOffStatus: '核销状态',
      writeOffTime: '核销时间',
      remark: '说明',
      operation: '操作',
      orderDetail: '订单详情'
    }
  }
}